"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ActionButton = function ActionButton(_ref) {
  var disabled = _ref.disabled,
      loading = _ref.loading,
      classes = _ref.classes,
      children = _ref.children,
      onClick = _ref.onClick;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    color: "secondary",
    disabled: disabled || loading,
    onClick: onClick
  }, children), loading && /*#__PURE__*/_react["default"].createElement(_core.CircularProgress, {
    size: 24,
    className: classes.buttonProgress
  }));
};

ActionButton.propTypes = {
  children: _propTypes["default"].node.isRequired,
  classes: _propTypes["default"].object.isRequired,
  disabled: _propTypes["default"].bool,
  loading: _propTypes["default"].bool,
  onClick: _propTypes["default"].func.isRequired
};
ActionButton.defaultProps = {
  disabled: false,
  loading: false
};

var _default = (0, _styles.withStyles)(_styles2["default"])(ActionButton);

exports["default"] = _default;